import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(0 3)">
      <path d="M32,27 L0,27 L0,0 L12.57,0 L15.57,5 L32,5 L32,27 Z M2,25 L30,25 L30,7 L14.43,7 L11.43,2 L2,2 L2,25 Z"/>
      <polygon className="euiIcon__fillSecondary" points="21 15 17 15 17 11 15 11 15 15 11 15 11 17 15 17 15 21 17 21 17 17 21 17"/>
    </g>
  </svg>
);
